// DIASTOLIC FUNCTION
export const DiastolicFields = [
  { title: "IVRT", range: ".89mm/sec 40YRS" },
  { title: "DT", range: "160-240 m/sec." },
  { title: "PV (A) WAVE", range: "<25/sec." },
  { title: "PV (5) FLOW", range: "m/sec." },
  { title: "PV (D) FLOW", range: "m/sec." },
  { title: "S/D RATIO", range: "" },
  { title: "IVC (D)", range: "" },
];
export default DiastolicFields;
